import { render, staticRenderFns } from "./InternalTestList.vue?vue&type=template&id=ec681b74&scoped=true&"
import script from "./InternalTestList.vue?vue&type=script&lang=js&"
export * from "./InternalTestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec681b74",
  null
  
)

export default component.exports